import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {EmailSettingEntityModel} from "../email-setting-entity.model";
import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {ConfigurationService, provideEntityModel} from "@fedeltapointofsale/data-client";
import {Config} from "../../../config";
import {Subscription} from "rxjs";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-email-setting-edit-page",
    templateUrl: "./email-setting-edit-page.component.html",
    providers: [provideEntityModel(EmailSettingEntityModel)]
})

export class EmailSettingEditPageComponent extends AbstractEditPage implements OnInit, OnDestroy {
    Config = Config;

    private subscriptions: Subscription = new Subscription();

    constructor(public model: EmailSettingEntityModel,
                private configService: ConfigurationService,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    ngOnInit(): void {
        this.subscriptions.add(this.model.$data.subscribe(async () => {
            this.model.data.systemEmailAddress = await this.configService.getString(Config.EMAIL_ADDRESS);
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
